module.exports = __webpack_public_path__ + "static/media/排行榜_0.2b0a77c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/HomeRankingModule/assets/images/排行榜_0.png
// module id = 418
// module chunks = 0